import { FALLBACK_SESSION_ID } from '../components/MagicApronAssistant/constants';
import { getUserName } from './assistant-context-utils';

/**
 * Returns a string to be used as session ID.
 *
 * @return { string }
 */
export const getSessionId = () => {
  return typeof window !== 'undefined'
    ? window?.cookieUtils?.readBrowserCookie('thda.s') || FALLBACK_SESSION_ID : FALLBACK_SESSION_ID;
};

export const getDefaultSession = () => ({
  sessionId: getSessionId(),
  timestamp: Date.now(),
  shouldOpenDrawer: true,
});

/**
 * @typedef { Object } Session
 * @property { string } sessionId - User ID string used as sessionId.
 * @property { number } timestamp - Timestamp when session was created.
 */

export const getInitialMessage = (sessionId) => {
  const authUser = getUserName();
  return {
    type: 'bot',
    content: {
      responseSummary: {
        // eslint-disable-next-line max-len
        summaryAnswer: `Hi${authUser ? `  ${authUser}` : ''}! Need help with a product, project, or question? I'm here to assist. What can I help you with today?`
      },
      suggestedQuestions: [],
    },
    sessionId,
    // Set to true since no feedback prompt should be shown for initial message
    feedbackProvided: true,
    timestamp: Date.now(),
    isInitialMessage: true,
  };
};
